/**
 * StorageService - Encapsulates sessionStorage management with clean API.
 */
class StorageService {
    /**
     * Set a value in sessionStorage.
     * @param {string} key 
     * @param {any} value 
     */
    setItem(key, value) {
        if (key === 'access_token' || key === 'refresh_token') {
            console.error(`[StorageService] SECURITY BLOCKED: Refusing to store '${key}' in sessionStorage to prevent XSS. Use HttpOnly cookies instead.`);
            return;
        }
        try {
            const stringValue = typeof value === 'object' ? JSON.stringify(value) : value;
            sessionStorage.setItem(key, stringValue);
        } catch (error) {
            console.error('[StorageService] Error setting item:', error);
        }
    }

    /**
     * Get a value from sessionStorage.
     * @param {string} key 
     * @param {boolean} isJson - Whether the value should be parsed as JSON.
     */
    getItem(key, isJson = true) {
        try {
            const value = sessionStorage.getItem(key);
            if (!value) return null;
            return isJson ? JSON.parse(value) : value;
        } catch (error) {
            console.error('[StorageService] Error getting item:', error);
            return null;
        }
    }

    /**
     * Remove an item from sessionStorage.
     * @param {string} key 
     */
    removeItem(key) {
        sessionStorage.removeItem(key);
    }

    /**
     * Clear all items from sessionStorage.
     */
    clear() {
        sessionStorage.clear();
    }
}

const storageServiceInstance = new StorageService();
export default storageServiceInstance;
